export const TMDB_API_URL = 'https://api.themoviedb.org/3';
export const URL_LIST = TMDB_API_URL + '/discover/movie';
export const URL_SEARCH = TMDB_API_URL + '/search/movie?query=';
export const URL_DETAIL = TMDB_API_URL + '/movie/';
export const URL_PERSON = TMDB_API_URL + '/person/';
export const URL_IMG = 'https://image.tmdb.org/t/p/';
export const URL_YOUTUBE = 'https://www.youtube.com/embed/';
export const URL_CAST = '/casts';
export const URL_VIDEO = '/videos';
export const IMG_SIZE_XSMALL = 'w45/';
export const IMG_SIZE_SMALL = 'w150/';
export const IMG_SIZE_LARGE = 'w342/';
export const CAST_MAX_NUM = 5;
export const TRAILER_MAX_NUM = 3;
export const TMDB_API_KEY = '1a310ae853a5b25f2ca396e205bcfa6d';
export const API_KEY = '?api_key=' + TMDB_API_KEY;
export const API_KEY_ALT = '&api_key=' + TMDB_API_KEY;


export const URL_TV_LIST = TMDB_API_URL + '/discover/tv';
export const URL_TV_SEARCH = TMDB_API_URL + '/search/tv?query=';
export const URL_TV_DETAIL = TMDB_API_URL + '/tv/';
export const URL_TV_PERSON = TMDB_API_URL + '/person/';
